module.exports = __webpack_public_path__ + "static/media/air-direction.641f5aeb.svg";